// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {

    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";



// App Imports
import Box from "@mui/material/Box";
import CalculateIcon from "@mui/icons-material/Calculate";
import {changeWorkQueue} from "../../workQueueSlice";


// main function
export default function CalcContract({ onMenuClose, rowContractData }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    const onCalc = (rowData) => {
        onMenuClose();
        console.log("Calcing Contract(s) from action menu");
        dispatchData(changeWorkQueue({
            actionMenuAction: "Calc", actionMenuState: false
        }))
    }


    return (

        <Box>
            {(
                    (
                               rowContractData.contractLevel !== "Option"
                            || rowContractData.contractLevel !== "Cast"
                            || rowContractData.contractLevel !== "Engagement")
                        &&
                        (rowContractData.comboStatus === "a")
                ) &&
                <MenuItem  onClick={onCalc}

                >
                    <ListItemIcon>
                        <CalculateIcon  fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Calc</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
